import React, { Suspense, useCallback, useEffect, useState } from 'react'
import { Provider, useDispatch, useSelector } from 'react-redux'
import { ModalProvider } from 'react-modal-hook'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persister } from './store'
import './AppSecurity'
import 'react-app-polyfill/ie11'
import AppRouter from './app.router'
import { ErrorBoundary } from 'react-error-boundary'
import Modal from './components/Modal/Modal'
import NeoButton from './components/NeoButton/NeoButton'
import { I18nextProvider } from 'react-i18next'
import i18n from './i18n'
import { getErrorMessageSelector } from './store/selectors/error.selector'
import { useTranslation } from 'react-i18next'
import { useModal } from 'react-modal-hook'
import { setErrorMessage } from './store/actions/error.actions'
import { setAppLanguage } from './store/actions/app.actions'
import i18next from "i18next";

export default function App() {
  //error message handle framework changes
  const errors = useSelector(getErrorMessageSelector)
  const dispatch = useDispatch()
  const [error, setError] = useState({})
  const { t } = useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <div className='modal-error-body'>
          <h6>
            <b>{error?.code || 'Error'}</b> :{' '}
            {error?.message || 'Error occurred, Please contact to bank'}
          </h6>
          {error?.errors && (
            <>
              <p>{'Error may occur below scenarios'}</p>
              <ul>
                {error?.errors?.map((option, index) => (
                  <li key={index}>{option}</li>
                ))}
              </ul>
            </>
          )}
          <div className='modal-btn-style'>
            <NeoButton
              mode='newDesign'
              type='button'
              text={'Ok'}
              onClick={() => {
                hideModal()
                dispatch(setErrorMessage(null))
              }}
            />
          </div>
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    dispatch(setAppLanguage('EN'))
    i18next.changeLanguage('EN')
  }, [])

  useEffect(() => {
    showErrors()
  }, [errors])

  const showErrors = useCallback(() => {
    try {
      if (errors) {
        if ((errors.status === 400 || errors.status === 0) && !errors?.data) {
          setError({
            code: 'Error',
            message: 'Error occurred, Please contact to bank',
            errors: null,
          })
        } else {
          setError(errors?.data)
        }
        showModal()
      }
    } catch (err) {}
  }, [errors])

  return <AppRouter />
}
